import { render, staticRenderFns } from "./PendingApprovalsSummaryTableRow.vue?vue&type=template&id=5d98d272"
import script from "./PendingApprovalsSummaryTableRow.vue?vue&type=script&lang=js"
export * from "./PendingApprovalsSummaryTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports